export default __webpack_public_path__ + "static/media/lottery-icon-active.21dbb951.webp";